<div class="d-flex align-items-center flex-wrap">
  <div class="p-1 font-weight-bolder">{{'date.from'|translate}}</div>
  <s-input [(model)]="dateFrom" type="date" (onEnter)="fromToChange()" (blur)="fromToChange()" max="9999-12-31"
    [customClass]="inputClass">
  </s-input>
  <div class="d-block d-md-none w-100 d-print-none"></div>
  <div class="ms-1 p-1 font-weight-bolder">{{'date.to'|translate}}</div>
  <s-input [(model)]="dateTo" type="date" (onEnter)="fromToChange()" (blur)="fromToChange()" max="9999-12-31"
    [customClass]="inputClass">
  </s-input>


  <div ngbDropdown class="ms-1 no-print">
    <button class="btn btn-outline-secondary" [ngClass]="btnClass"  type="button" ngbDropdownToggle>
      <i class="bi bi-calendar"></i>
    </button>
    <div ngbDropdownMenu>
      @for (btn of btns; track btn) {
        <div ngbDropdownItem class="cursor" (click)="selectDates(btn)">
        {{('date.'+btn)|translate}}</div>
      }
    </div>
  </div>
</div>
